import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { RightCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { StyledTable } from '../shared';
import { tableColumns } from './helpers';
import { Loading } from 'Components'
import Jobs from '../Jobs'
import moment from 'moment';

const unixEpoch = "1969-12-31T23:59:59.000Z";

const TaskTable = ({ orchestrator }) => {

  const { location } = useHistory();
  const [expandedRowKey, setExpandedRowKey] = useState(location.state)
  const [showConfig, setShowConfig] = useState(false)

  const getTasks = async () => {
    const res = await orchestrator.getSchedules();
    return JSON.parse(res);
  }

  const { data, isLoading } = useQuery({
    queryKey: ['pipelines.tasks'],
    queryFn: getTasks,
    refetchInterval: 60000
  })

  const reduceTaskData = (tasks = []) => {
    const parsed = tasks.map((item) => {
      const { crons, uid, config: { functionality }} = item
      return {
        ...item,
        functionality,
        key: uid,
        active: crons.find(({ nextRun }) => moment(nextRun).isAfter(unixEpoch)) || false,
        recurring: crons.find(({ cron, runOnce }) => (cron.value !== undefined && runOnce === false)) || false,
        nextRun: crons.filter(({ nextRun }) => moment(nextRun).isAfter(moment())).map(({ nextRun }) => nextRun),
      }
    })

    return _.orderBy(parsed, ['created'],['desc'])
  }

  if (isLoading) {
    return <Loading />
  } else {
    return (
      <StyledTable
        data-testid="pipelines-task-table"
        columns={tableColumns(setExpandedRowKey, setShowConfig)}
        expandable={{
          expandRowByClick: false,
          expandedRowKeys: [expandedRowKey],
          expandedRowRender: ({ uid }, index, indent, expanded) => expanded ? <Jobs uid={uid} orchestrator={orchestrator} showConfig={showConfig}/> : null,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (expanded) {
              return <DownCircleOutlined onClick={(e) => {
                setShowConfig(false)
                setExpandedRowKey(undefined)
                onExpand(record, e)}
              }/>
            } else {
              return <RightCircleOutlined onClick={(e) => {
                setExpandedRowKey(record.key)
                onExpand(record, e)}
              }/>
            }
          }
        }}

        dataSource={data ? reduceTaskData(data) : []}
      />
    )
  }
}


export default TaskTable
